<template>
  <div class="commodity">
    <el-button @click="back" class="back-button">{{
      $t("B2C.back")
    }}</el-button>
    <div class="commodity-title">
      <span v-if="form.PId">{{ $t("B2C.editProduct") }}</span>
      <span v-else>{{ $t("B2C.addProduct") }}</span>
    </div>
    <el-form :model="form" :rules="rules" ref="form" class="form-box">
      <el-form-item :label="$t('B2C.productClass')" prop="ClassValue">
        <el-cascader
          v-model="form.ClassValue"
          :placeholder="$t('B2C.select')"
          ref="cascader"
          :options="ClassOptions"
          :props="{
            label: 'ClassName',
            value: 'BPCId',
            children: 'SubClassList'
          }"
          popper-class="public-cascader"
          style="width:100%;"
          clearable
        >
        </el-cascader>
      </el-form-item>

      <el-form-item :label="$t('B2C.productName')" prop="ProductName">
        <el-input
          :placeholder="$t('B2C.input')"
          v-model="form.ProductName"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item :label="$t('B2C.productModel')">
        <el-input
          :placeholder="$t('B2C.input')"
          v-model="form.ProductModel"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item :label="$t('B2C.productFeatures')">
        <el-input
          :placeholder="$t('B2C.input')"
          v-model="form.ProductFeatures"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item :label="$t('B2C.productDesc')">
        <vue-html5-editor
          ref="editor"
          :height="500"
          style="width: 100%;display: block;"
          :show-module-name="true"
          :content="form.ProductDescription"
          @change="updateContentData"
        >
        </vue-html5-editor>
      </el-form-item>
      <el-form-item :label="$t('B2C.customize')">
        <el-radio-group v-model="form.IsCustomizable">
          <el-radio :label="0">{{ $t("B2C.no") }}</el-radio>
          <el-radio :label="1">{{ $t("B2C.yes") }}</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item :label="$t('B2C.isShowcase')">
        <el-radio-group v-model="form.IsSetProductShowcase">
          <el-radio :label="0">{{ $t("B2C.no") }}</el-radio>
          <el-radio :label="1">{{ $t("B2C.yes") }}</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item :label="$t('B2C.productState')">
        <el-radio-group v-model="form.ProductState">
          <el-radio :label="0">{{ $t("B2C.pState2") }}</el-radio>
          <el-radio :label="1">{{ $t("B2C.pState1") }}</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item :label="$t('B2C.productionTime')">
        <el-input
          :placeholder="$t('B2C.input')"
          v-model="form.ProductionTime"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item :label="$t('B2C.fileList')" prop="FileList">
        <uploader
          style="margin-top: 10px;"
          :urls="form.FileList"
          :max="5"
          :type="'photo'"
          @change="handlePhotosChanged"
          @top="handlePhotosTop"
          ref="photoUploader"
        ></uploader>
        <span class="desc wrap">{{ $t("B2C.uploadText") }}</span>
      </el-form-item>
    </el-form>
    <el-button type="primary" @click="handleSubmit" class="submit-btn" round>{{
      $t("B2C.submit")
    }}</el-button>
  </div>
</template>
<script>
export default {
  name: "commodityEdit",
  data() {
    return {
      ClassIndex: 1,
      ClassOptions: [],
      form: {
        PId: "",
        ClassValue: [],
        BPCId: "",
        ProductName: "",
        ProductModel: "",
        ProductFeatures: "",
        ProductDescription: "",
        IsCustomizable: 0,
        IsSetProductShowcase: 0,
        ProductState: 0,
        ProductionTime: "",
        FileList: []
      },
      rules: {
        ClassValue: [
          {
            required: true,
            message: this.$t("B2C.select") + this.$t("B2C.productClass")
          }
        ],
        ProductName: [
          {
            required: true,
            message: this.$t("B2C.input") + this.$t("B2C.productName")
          }
        ],
        FileList: [
          {
            type: "array",
            required: true,
            message: this.$t("B2C.uploadRuleText1")
          },
          {
            type: "array",
            min: 3,
            max: 5,
            message: this.$t("B2C.uploadRuleText2")
          }
        ]
      }
    };
  },
  mounted() {
    const { ProductNumber } = this.$route.query;
    this.form.PId = ProductNumber || "";
    this.getBusinessProductClassList().then(success => {
      if (success) {
        if (this.form.PId) {
          this.getSupplierProductInfo();
        }
      }
    });
  },
  methods: {
    updateContentData(data) {
      this.form.ProductDescription = data;
    },
    getSupplierProductInfo() {
      return new Promise(resolve => {
        let param = {
          PId: this.form.PId
        };
        this.$api.product
          .getSupplierProductInfo(param)
          .then(res => {
            var data = res.data || {};
            if (data) {
              var files = [];
              for (const list of data.FileList) {
                files.push(list.FileAddress);
              }
              data.FileList = files;
            }
            this.form = data;
            this.form.ClassValue = data.ClassList;

            this.$nextTick(_ => {
              this.$refs.photoUploader.reloadData();
            });
            resolve(true);
          })
          .catch(err => {
            this.$message.error(err.message);
          });
      });
    },
    getBusinessProductClassList() {
      return new Promise(resolve => {
        let param = {};
        this.$api.product
          .getBusinessProductClassList(param)
          .then(res => {
            const data = res.data || [];
            this.getIndex(data);
            this.ClassOptions = data;

            resolve(true);
          })
          .catch(err => {
            this.$message.error(err.message);
          });
      });
    },
    getIndex(data) {
      for (var c1 in data) {
        var item1 = data[c1];
        for (var c2 in item1.SubClassList) {
          var item2 = item1.SubClassList[c2];
          if (item2.ParentId == item1.BPCId) {
            if (item2.SubClassList == null) {
              this.ClassIndex = 1;
            } else {
              for (var c3 in item2.SubClassList) {
                var item3 = item2.SubClassList[c3];
                if (item3.SubClassList == null) {
                  this.ClassIndex = 2;
                }
              }
            }
          }
        }
      }
      return data;
    },
    back() {
      this.$router.back(-1);
    },
    handlePhotosChanged(images) {
      this.form.FileList = images.map(image => {
        return image.state === "success" ? image.url : "";
      });
    },
    handlePhotosTop(images) {
      this.form.FileList = images.map(image => {
        return image.state === "success" ? image.origin : "";
      });
    },
    handleSubmit() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          let files = [];
          if (this.form.FileList.length > 0) {
            for (let index in this.form.FileList) {
              if (index == 0) {
                files.push({
                  FileAddress: this.form.FileList[index],
                  IsCover: 1
                });
              } else {
                files.push({
                  FileAddress: this.form.FileList[index],
                  IsCover: 0
                });
              }
            }
          }
          let param = { ...this.form };
          param.FileList = files;
          param.BPCId = this.form.ClassValue[this.ClassIndex];

          this.$api.product
            .saveSupplierProductInfo(param)
            .then(() => {
              this.$message({
                message:  this.$t("B2C.submitSuccess"),
                type: "success"
              });
              this.back();
            })
            .catch(err => {
              this.$message.error(err.message);
            });
        } else {
          return false;
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>

.commodity {
  padding-bottom: 10%;
  background: rgb(246, 246, 246);

  .back-button {
    left: 3%;
    top: 4%;
    font-size: 14px;
    position: absolute;
    z-index: 11;
  }
  .submit-btn {
    min-width: 300px;
    display: block;
    margin: 30px auto 0;
  }
  .commodity-title {
    width: 50%;
    font-size: 25px;
    margin: auto;
    text-align: center;
    padding: 30px;
    background: #fff;
    margin-bottom: 20px;
  }
  .form-box {
    width: 50%;
    margin: auto;
    padding: 30px;
    background: #fff;

    ::v-deep .el-select {
      margin-left: 30px;
    }

    .el-radio-group {
      margin-left: 30px;
    }

    .el-form-item {
      margin-bottom: 20px;
    }

    .breadcrumb.inline {
      display: inline-block;
      margin-right: 16px;
      font-weight: normal;
    }
    ::v-deep .el-input.is-disabled .el-input__inner {
      background-color: #ffffff !important;
      color: #000 !important;
    }
    .textfield {
      display: inline-block;
      width: 100%;
      &.mini {
        width: 80px;
        min-width: 80px;
      }

      &.small {
        min-width: 160px;
      }

      .prefix {
        font-style: normal;
        margin-left: 10px;
        color: black;
      }
      .suffix {
        font-style: normal;
        margin-right: 10px;
        color: black;
      }
    }
    .small-textarea {
      display: inline-block;
      width: auto;
      min-width: 380px;
    }
    .tBUrlInput {
      display: inline-block;
      width: auto;
      min-width: 500px;
    }
    .textareatBUrl {
      word-wrap: break-word;
      width: 70%;
    }
    .red-text {
      font-weight: bold;
      color: red;
    }
    .unit {
      padding: 5px;
    }
    .desc {
      font-size: 12px;
      color: #989898;
      margin-left: 10px;
      &.wrap {
        display: block;
        line-height: 24px;
        margin-left: 0;
      }
    }
    .el-tag + .el-tag {
      margin-left: 10px;
    }
    .button-new-keyword {
      margin-left: 10px;
      height: 32px;
      line-height: 30px;
      padding-top: 0;
      padding-bottom: 0;
    }
    .input-new-keyword {
      width: 90px;
      margin-left: 10px;
      vertical-align: bottom;
    }

    .gray-box {
      margin-top: 16px;
      padding: 30px 20px;
      background-color: #fbf9f9;
      border-radius: 13px;
    }
    .freight-desc-box {
      font-size: 12px;
      line-height: 12px;
      color: black;

      > p {
        margin-top: 12px;
        margin-bottom: 0;

        span {
          color: #22b196;
        }
      }
    }
    .normal-checkbox {
      font-weight: normal;
    }
    .tag-checkbox-group {
      padding-bottom: 20px;
      border-bottom: 1px dashed #ccc;
    }
    .tag-box + .tag-box {
      margin-top: 20px;
    }
    .input-new-tag {
      width: 68px;
      margin-left: 25px;
    }
    .button-new-tag {
      margin-left: 25px;
    }
    .checkbox-delete {
      margin-left: 5px;
      background-color: #989898;
      color: white;
      border-radius: 50%;
      text-align: center;
    }
  }
}
</style>
